"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const transactionSigningSelector_1 = require("@/features/transaction-signing/selectors/transactionSigningSelector");
//import { FormattedMessage, injectIntl, useIntl, WrappedComponentProps } from 'react-intl'
const react_intl_1 = require("react-intl");
const react_design_system_1 = require("@hdh-core/react-design-system");
const transactionSigningAction_1 = require("../actions/transactionSigningAction");
const ChangePasswordOneToken = ({ onClose }) => {
    const { showChangePasswordOneToken, expirySecs } = (0, react_redux_1.useSelector)(transactionSigningSelector_1.transactionSigningSelector);
    const intl = (0, react_intl_1.useIntl)();
    const dispatch = (0, react_redux_1.useDispatch)();
    //const [isOpen, setOpen] = useState(true)
    const [isOpen] = (0, react_1.useState)(true);
    const [resendMessage, setResendMessage] = (0, react_1.useState)(false);
    const [timer, setTimer] = (0, react_1.useState)(expirySecs);
    const [startTimer, setStartTime] = (0, react_1.useState)(false);
    const handleToggleCloseOneToken = () => {
        console.log('handleToggleCloseOneToken');
        setStartTime(false);
        dispatch((0, transactionSigningAction_1.toggleCloseOneToken)());
        onClose();
    };
    (0, react_1.useEffect)(() => {
        //NOSONAR
        if (startTimer) {
            const intervalId = setInterval(() => {
                setTimer(t => t - 1);
            }, 1000);
            if (timer <= 0) {
                clearInterval(intervalId);
                return () => clearInterval(intervalId);
            }
            return () => clearInterval(intervalId);
        }
        return null;
    }, [timer, startTimer]);
    const handleToggleChangePasswordResendNotification = () => {
        console.log('handleToggleResendNotification');
        dispatch((0, transactionSigningAction_1.toggleChangePasswordResendNotification)());
        setTimer(expirySecs);
        setResendMessage(true);
    };
    const handleToggleGenerateChangePasswordOtp = () => {
        dispatch((0, transactionSigningAction_1.toggleGenerateChangePasswordOtp)());
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_design_system_1.ConfirmDialog, { isOpen: isOpen, setOpen: showChangePasswordOneToken, title: intl.formatMessage({ id: 'change-password-soft-token-title' }), iconType: "soft-token", message: intl.formatMessage({ id: 'change-password-msg' }), leftBtnLabel: intl.formatMessage({ id: 'common.button.btnCancel' }), onCancelClick: handleToggleCloseOneToken, rightBtnLabel: intl.formatMessage({ id: 'common.button.btnResend' }), onConfirmClick: handleToggleChangePasswordResendNotification, rightBtnDisabled: timer !== 0, hasTimer: true, timerLabel: intl.formatMessage({ id: 'transaction-signing-timeRemaining' }), timerCounter: timer + intl.formatMessage({ id: 'transaction-signing-second' }), hasResendMessage: true, isResendMessageInReactNode: true, resendNotificationMessage: resendMessage ?
                react_1.default.createElement(react_design_system_1.Box, { className: "rds-text-center" },
                    react_1.default.createElement(react_design_system_1.Text, { className: "rds-text-sm rds-text-center" },
                        intl.formatMessage({ id: 'transaction-signing-resendMessage1' }),
                        react_1.default.createElement("br", null),
                        react_1.default.createElement(react_design_system_1.ButtonLink, { underline: true, bold: true, onClick: handleToggleGenerateChangePasswordOtp, className: "rds-text-information" }, intl.formatMessage({ id: 'transaction-signing-clickHere' })),
                        intl.formatMessage({ id: 'transaction-signing-resendMessage2' }))) :
                react_1.default.createElement(react_design_system_1.Box, { className: "rds-text-center" },
                    react_1.default.createElement(react_design_system_1.Text, { className: "rds-text-sm rds-text-center", isHTMLTextFormatting: true, htmlText: intl.formatMessage({ id: 'transaction-signing-notReceivedNotification' }) })) }),
        !startTimer ? setStartTime(true) : null));
};
exports.default = ChangePasswordOneToken;
